import {
  getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags,
  getGetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  threeLetterCode: string;
};

type ReturnType = {
  data: GetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags200;
};

type IUseGetPartnerAdminsClientFeatureFlags = (args: Args) => ReturnType;

/**
 * 利用企業のクライアント機能フラグ一覧を取得するカスタムフック
 *
 * @param args.threeLetterCode - パートナーを識別する3文字コード
 * @returns data - クライアント機能フラグ一覧
 */
export const useGetPartnerAdminsClientFeatureFlags: IUseGetPartnerAdminsClientFeatureFlags = ({
  threeLetterCode,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsClientFeatureFlagsKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsClientFeatureFlags(threeLetterCode),
    { suspense: true }
  );
  return { data };
};
